import CaseSteelBlack from "../images/customisation-assets/Case_Steel_Black.png";
import CaseSteelSilver from "../images/customisation-assets/Case_Steel_Silver.png";
import CaseTitanium from "../images/customisation-assets/Case_Titanium.png";
import OptionSteelBlack from "../images/customisation-option-icons/steel_black.png";
import OptionSteelSilver from "../images/customisation-option-icons/steel_silver.png";
import OptionTitanium from "../images/customisation-option-icons/titanium.png";

// Thumbnails
import CaseSteelBlackThumb from "../images/customisation-asset-thumbnails/Case_Black_Steel_50x50.png";
import CaseSteelSilverThumb from "../images/customisation-asset-thumbnails/Case_Silver_Steel_50x50.png";
import CaseTitaniumThumb from "../images/customisation-asset-thumbnails/Case_Titanium_50x50.png";

export const CASE_OPTIONS = {
  steelBlack: {
    title: "Steel Black",
    watchLayerAsset: CaseSteelBlack,
    watchLayerThumbnail: CaseSteelBlackThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionSteelBlack,
    },
  },
  steelSilver: {
    title: "Steel",
    watchLayerAsset: CaseSteelSilver,
    watchLayerThumbnail: CaseSteelSilverThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionSteelSilver,
    },
  },
  titanium: {
    title: "Titanium (+£100)",
    watchLayerAsset: CaseTitanium,
    watchLayerThumbnail: CaseTitaniumThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionTitanium,
    },
  },
};
